import { store } from 'app_storage/redux-storage'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import EditorService from '../editorService';
import storeService from 'app_services/storeService';
import { IFieldTabEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import RouterService, { IQueryParamsURL } from 'app_services/router/routerService';
import { TypeAcademicResourceCategories } from 'app_types/userTypes';
import { routingService } from 'app_services/routingService';
import QuestionsService from 'app_services/editor/questions/questionsService';

type TypesActionOnChangeEditorData = 'create' | 'delete' | 'duration'
export interface IOnChangeEditorData{
  user: string
  alliance: string
  hierarchy?: {
    course?: string
    chapter?: string
    lesson?: string
    resource?: string
  }
  action: TypesActionOnChangeEditorData
}

interface IAcademicResourceConfigCategory{
  _id: string
  name: string
  description: string
  config?: any
}

interface IOptionSelect{
  label: string
  value: string
}

interface IConfigGetPossibleLaunchConfig{
  optionsAcademicComponents?: IOptionSelect[]
}

export interface IExtradataUpdateResourceEditor{
  duration?: string
  metadata?: any[]
  showAlert?: boolean
  resourceData?: any
}

type ITypeAcademicResourceConfigCategories = 'survey'

type ITypesCatalogerResources = 'create_exercise' | 'create_editor' | 'create_attached' | 'create_game' | 'create_simulacrum' | 'create_video' | 'create_homework' | 'create_virtual-tutoring'

class CatalogerService {

  private screenNotification: ScreenNotificationsUtil
  private storeObject = store
  private editorService: EditorService
  private routerService: RouterService
  // private simulacrumService: SimulacrumService
  // private academicComponentService: AcademicComponentService
  private questionsService: QuestionsService

  constructor() {
    this.screenNotification = new ScreenNotificationsUtil()
    this.editorService = new EditorService()
    this.routerService = new RouterService()
    // this.simulacrumService = new SimulacrumService()
    // this.academicComponentService = new AcademicComponentService()
    this.questionsService = new QuestionsService()
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @INFO Obtener la data de un recurso
   * @param query
   */
  getResourceData = async (query?: URLSearchParams) => {
    const paramsURL = this.getQueryParamsUrl(query)
    if(paramsURL.survey){
      const category = await this.getAcademicResourceConfigCategoryFromName('survey')
      const response = await this.editorService.getAcademicResourceData(
        this.getParamsResourceData(query),
        category?._id
      )
      // @INFO Ordeno las preguntas antes de devolver la respuesta
      if(response?.academicResourceData?.category?.name === 'exercise' && response?.academicResourceData?.config?.questions?.length){
        response.academicResourceData.config.questions = this.questionsService.orderQuestions([...response.academicResourceData.config.questions])
      }
      return response
    }
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @INFO Obtener parámetros para consulta de data de un recurso
   * @param query
   */
  getParamsResourceData = (query?: URLSearchParams) => {
    const paramsURL = this.getQueryParamsUrl(query)
    let params: any = {}
    if(paramsURL.survey){
      params.survey = paramsURL.survey
      params.academic_resource_config = paramsURL.config
    }
    return params
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @INFO Obtener URL de return
   * @param query
   */
  getUrlReturn = (query?: URLSearchParams) => {
    const paramsURL = this.getQueryParamsUrl(query)
    let response:string = ''
    if(paramsURL.survey){
      response = '/survey-list'
    }
    return routingService.getSecurePath(response)
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @INFO Actualizar el contenedor del recurso
   * @param query
   * @param params
   * @param typeResource
   */
  updateResourceContainer = async (query: URLSearchParams, params: any ) => {
    const paramsURL = this.getQueryParamsUrl(query)
    let response: any = {}
    if(paramsURL.survey){
      // const dataSurvey = new FormData()
      const dataSurvey: any = {}
      dataSurvey.name = params.name
      dataSurvey.status = params.active ? "enabled" : "disabled"
      dataSurvey.description = params.description
      // dataSurvey.append('name', params.name)
      // dataSurvey.append('status', params.active ? "enabled" : "disabled")
      // dataSurvey.append('description', params.description)
      response = await this.editorService.updateSurvey(
        {
          data: dataSurvey,
          id: paramsURL.survey,
        }
      )
    }
    return response
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @param params
   * @param type
   * @param id
   * @param query
   * @param alliance_id
   */
  updateAcademicResource = async (params: any, type: TypeAcademicResourceCategories, id: string, options?: {query?: URLSearchParams, allianceId?: string, responseApi?: any, showAlert?: boolean}) => {
    const paramsURL = this.getQueryParamsUrl(options?.query)
    let response: any = {}
    if(paramsURL.survey){
      response = await this.editorService.updateAcademicResource(
        storeService?.getAcademicResourceCategoryFromName(type) as string,
        id,
        params
      )
      if(response.code === 200){
        this.showAlertSuccess(options?.showAlert)
      }else{
        this.showAlertError(options?.showAlert)
      }
    }
    return response
  }

  /**
   * TODO: Cambiar según el contenedor del recurso
   * @INFO Obtener los campos del tab general
   * @param query
   * @param defaultValues
   */
  getFieldsGeneral = (query: URLSearchParams, defaultValues: any) => {
    const paramsURL = this.getQueryParamsUrl(query)

    let fields: IFieldTabEditor[] = []

    if(paramsURL.survey){
      fields = [
        {type: 'title', value: defaultValues.name, keyApi: 'name'},
        {type: 'description', value: defaultValues.description},
        {type: 'active', value: defaultValues.status === 'enabled' ? true : false },
        // {type: 'duration', value: defaultValues.config?.duration},
      ]
    }
    return fields
  }

  /**
   * @INFO Obtener parámetros de la url
   * @param queryIn | query de parámetros de url
   */
  private getQueryParamsUrl = (queryIn?: URLSearchParams) => {
    let query = new URLSearchParams(window.location.search)
    if(queryIn){
      query = queryIn
    }
    // @INFO Convertir el URLSearchParams a objeto
    let response: IQueryParamsURL = this.routerService.getParamsURLObject(query)
    response = Object.keys(response).reduce((acum: IQueryParamsURL, item: string) => {
      // @ts-ignore
      if(response[item] === null){
        // @ts-ignore
        acum[item] = undefined
      }else{
        // @ts-ignore
        acum[item] = response[item]
      }
      return acum
    }, {})
    return response
  }

  /**
   * @INFO Mostrar el alert de Correcto
   */
  public showAlertSuccess = (show?: boolean) => {
    if(!show) return
    this.screenNotification.fire(
      {
        message: 'Cambios guardados correctamente'
      },
      {
        timer: 1500,
        icon: 'success',
        showConfirmButton: false
      }
    )
  }

  /**
   * @INFO Mostrar el alert de Error
   */
  public showAlertError = (show?: boolean) => {
    if(!show) return
    this.screenNotification.fire(
      {
        message: 'Ha ocurrido un error al guardar los cambios'
      },
      {
        timer: 1500,
        icon: 'error',
        showConfirmButton: false
      }
    )
  }

  /**
   * @INFO Abrir el catalogador del recurso
   */
  public openResourceOnCataloger = (_params: IQueryParamsURL, prefix: ITypesCatalogerResources) => {
    const params = Object.keys(_params).reduce((accum: Object, item: string) => {
      // @ts-ignore
      if(_params[item]){
        accum = {
          ...accum,
          // @ts-ignore
          [item]: _params[item]
        }
      }
      return accum
    }, {})
    // @INFO Formar la url
    const privateRoute = routingService.getSecurePath('/editor')
    const url = Object.keys(params).reduce((accum: string, item: string, idx: number) => {
      if(idx === 0){
        accum = `${accum}?`
      }
      if(idx === Object.keys(params).length - 1){
        // @ts-ignore
        accum = `${accum}${item}=${params[item]}`
      }else{
        // @ts-ignore
        accum = `${accum}${item}=${params[item]}&`
      }

      return accum
    }, `${window.location.origin}${privateRoute}/${prefix}`)
    // @INFO Abrir la url en una pestaña nueva
    window.open(url, '_blank', 'noreferrer')
  }

  /**
   * @INFO Obtener AcademicResourceConfigCategory según el nombre
   * @param type
   * @returns
   */
  public getAcademicResourceConfigCategoryFromName = async (type: ITypeAcademicResourceConfigCategories) => {
    const response = await this.editorService.getAcademicResourceConfigCategories()
    if(response.code !== 200) return undefined
    const categories = response.categories
    if(!categories?.length) return undefined
    const category: IAcademicResourceConfigCategory = categories.find((item: any) => item.name === type)
    return category
  }

  /**
   * @INFO Obtener el tipo de catalogador a mostrar
   * @param category
   * @returns
   */
  public getCatalogerType = (category: TypeAcademicResourceCategories) => {
    if(!category) return undefined
    switch(category){
      case 'survey':
        return 'create_survey'
      default:
        return undefined
    }
  }

  /**
   * @INFO Obtener las posibles configuraciones del recurso
   * @param options
   * @param launchConfig
   * @param defaultModules
   * @param _config
   * @returns
   */
  public getPossibleLaunchConfigFields = (options: any, launchConfig?: any, defaultModules?: any[], _config?: IConfigGetPossibleLaunchConfig ) => {
    let items: IFieldTabEditor[] = []
    let defaultModulesArray: any[] = []
    let launchConfigAux: any = {}
    if(options === undefined) return items
    // Configurar módulos por defecto
    if(defaultModules){
      defaultModulesArray = Object.keys(defaultModules)
    }
    // Configurar launch config
    if(launchConfig){
      if(launchConfig && launchConfig.length){
        launchConfigAux = (launchConfig as string[]).reduce((acum: any, item) => {
          // @ts-ignore
          acum[item] = true
          return acum
        },{})
      }else if(launchConfig && launchConfig.length === undefined) {
        launchConfigAux = launchConfig
      }
    }
    const newItems = Object.keys(options).reduce((acum: IFieldTabEditor[], item) => {
      if(options[item] === true){
        const type = item.replace('has_', '')
        let aux: IFieldTabEditor = {
          // @ts-ignore
          type: type,
          value: launchConfigAux[type],
          required: false
        }
        // Verificar el modulo por defecto
        if(defaultModulesArray.length){
          if(
            (launchConfigAux[type] === undefined ||
            launchConfigAux[type] === null) &&
            defaultModulesArray.includes(type) &&
            defaultModules
          ){
            // @ts-ignore
            aux.value = defaultModules[type]
          }
        }
        // Excepciones
        if(type === 'game'){
          aux.required = true
        }

        // @INFO Si tiene la opción de campos relacionados organizo las opciones y el valor por defecto
        if(type === 'components_related'){
          if(_config?.optionsAcademicComponents?.length){
            aux.options = [..._config.optionsAcademicComponents]
            if((aux.value as string[])?.length){
              const newValue = (aux.value as string[]).reduce((accum: IOptionSelect[], itemValue) => {
                const element = (aux.options as IOptionSelect[])?.find(item => item.value === itemValue)
                if(element){
                  accum.push({
                    label: element.label,
                    value: element.value
                  })
                }
                return accum
              }, [])
              aux.value = [...newValue]
            }
          }
        }

        if(type !== 'navigation'){
          acum.push({...aux})
        }

      }
      return acum
    }, [])

    // Guardar los items
    items = [...items, ...newItems]

    return items
  }

}



export default CatalogerService
